import {
  AdditionalInfoStatus,
  BankVerificationStatus,
  IdentityVerificationStatus,
  RiskProfileStatus,
} from "Infrastructure/Api/Api";

export type VerificationStatus = "verified" | "pending" | "not-verified";

export const additionalInfoStatusMap: Record<
  AdditionalInfoStatus,
  VerificationStatus
> = {
  [AdditionalInfoStatus.Verified]: "verified",
  [AdditionalInfoStatus.NotVerified]: "not-verified",
  [AdditionalInfoStatus.NeedsInvestigation]: "pending",
};

export const identityVerificationStatusMap: Record<
  IdentityVerificationStatus,
  VerificationStatus
> = {
  [IdentityVerificationStatus.Verified]: "verified",
  [IdentityVerificationStatus.NotVerified]: "not-verified",
  [IdentityVerificationStatus.Processing]: "pending",
  [IdentityVerificationStatus.ToVerify]: "pending",
  [IdentityVerificationStatus.Expired]: "not-verified",
};

export const riskProfileStatusMap: Record<
  RiskProfileStatus,
  VerificationStatus
> = {
  [RiskProfileStatus.LowRisk]: "verified",
  [RiskProfileStatus.MediumRisk]: "verified",
  [RiskProfileStatus.HighRisk]: "verified",
  [RiskProfileStatus.NotVerified]: "not-verified",
  [RiskProfileStatus.Unacceptable]: "not-verified",
};

export const bankVerificationStatusMap: Record<
  BankVerificationStatus,
  VerificationStatus
> = {
  [BankVerificationStatus.Verified]: "verified",
  [BankVerificationStatus.NotVerified]: "not-verified",
  [BankVerificationStatus.InProgress]: "pending",
};
